module.exports = __webpack_public_path__ + "static/media/lagportalen.4b0375ab.png";